import { Link } from 'react-router-dom';

export default function Footer() {
  const serviceAreas = [
    { name: 'Chorleywood', slug: 'chorleywood' },
    { name: 'Rickmansworth', slug: 'rickmansworth' },
    { name: 'Northwood', slug: 'northwood' },
    { name: 'Pinner', slug: 'pinner' },
    { name: 'Bushey', slug: 'bushey' },
    { name: 'Radlett', slug: 'radlett' },
    { name: 'Gerrards Cross', slug: 'gerrards-cross' },
    { name: 'Watford', slug: 'watford' },
  ];

  return (
    <footer className="bg-beige-100 text-neutral-800 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <div className="inline-block bg-white rounded-full p-3 shadow-md">
                <img
                  src="https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F37cf9555ec8743aabbbe79e5c48f3558&methods=resize%2C1000%2C5000"
                  alt="Brushour Logo"
                  className="h-12"
                />
              </div>
            </div>
            <nav className="flex flex-wrap gap-6 mb-8">
              <Link
                to="/"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                About Us
              </Link>
              <Link
                to="/services"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                Services
              </Link>
              <Link
                to="/testimonials"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                Testimonials
              </Link>
              <Link
                to="/socials"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                Socials
              </Link>
              <Link
                to="/booking"
                className="text-sm font-medium hover:text-amber-600 transition-colors duration-300 whitespace-nowrap"
              >
                Book Visit
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-neutral-800">Service Areas</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {serviceAreas.map((area) => (
                <li key={area.slug}>
                  <Link
                    to={`/areas/${area.slug}`}
                    className="text-sm text-neutral-600 hover:text-amber-600 transition-colors duration-300 flex items-center gap-1 whitespace-nowrap"
                  >
                    <i className="ri-map-pin-2-line text-amber-500 text-xs"></i>
                    {area.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-neutral-800">Like. Share. Follow</h3>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.facebook.com/brushour"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-sky-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fab fa-facebook text-xl"></i>
                Facebook
              </a>
              <a
                href="https://x.com/brushour"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-sky-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fab fa-x-twitter text-xl"></i>
                X
              </a>
              <a
                href="https://www.instagram.com/brushour_"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-sky-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fab fa-instagram text-xl"></i>
                Instagram
              </a>
              <a
                href="https://www.youtube.com/@brushour"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-sky-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fab fa-youtube text-xl"></i>
                YouTube
              </a>
              <a
                href="https://maps.app.goo.gl/aKHCQ3m9gctrcMQ76"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-sky-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fab fa-google text-xl"></i>
                Google
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-neutral-800">Rated Excellent</h3>
            <a
              href="https://www.trustpilot.com/review/brushour.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block group cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="flex items-center gap-1">
                  <i className="fas fa-star text-amber-500 text-lg"></i>
                  <i className="fas fa-star text-amber-500 text-lg"></i>
                  <i className="fas fa-star text-amber-500 text-lg"></i>
                  <i className="fas fa-star text-amber-500 text-lg"></i>
                  <i className="fas fa-star-half-alt text-amber-500 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-neutral-800">4.8</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-neutral-600 group-hover:text-amber-600 transition-colors duration-300">
                <span className="font-medium">Trustpilot</span>
                <span>•</span>
                <span>94 reviews</span>
                <i className="ri-external-link-line text-base"></i>
              </div>
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-beige-300">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-neutral-600">
              © 2026 Brushour - Painters and Decorators
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy"
                className="text-sm text-neutral-600 hover:text-amber-600 transition-colors duration-300 cursor-pointer"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm text-neutral-600 hover:text-amber-600 transition-colors duration-300 cursor-pointer"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
